/*
  TILT – szybkie przełączanie kolekcji bez przeładowania (3.11.2026, tylko DEV; decyzja Pawła: UX klientów ważniejszy niż statystyki).
  Klik w kafelek paska (.tct__tile z data-cid): od razu podświetlenie, nagłówek i nowy adres (pushState),
  HTML nowej strony (zwykle już pobrany po najechaniu / dotknięciu kafelka) → podmiana sekcji: baner (tca_hero), pasek (tca_tiles),
  siatka Boost (sekcja z .boost-sd__filter-product-list – produkty są w niej już wyrenderowane po stronie serwera), opis (tca_about), tytuł karty;
  potem Boost ponownie się podpina (boostSDTaeUtils.initCollectionFilter) do nowej siatki – filtry i sortowanie działają.
  Nagłówek strony, skrypty aplikacji i obrazki nie ładują się od nowa.
  Na spokojnie po wczytaniu strony pobieramy w tle HTML kafelków Bestsellery / Nowości i sąsiadów bieżącego (nie przy oszczędzaniu danych / wolnym łączu).
  Wstecz/dalej działa (stan w history.state). Gdy coś się nie zgadza (szablon bez naszych sekcji, błąd sieci, Boost niegotowy) – zwykłe przejście na stronę.
  Uwaga: takie przejście nie jest liczone jako nowa odsłona w statystykach (Shopify / GA / Meta).
  Wycofanie: usunąć <script src="tilt-softnav.js"> z sekcji tilt-collection-tiles.
*/
(function () {
  if (window.__tiltSoft) return;
  window.__tiltSoft = true;
  if (!window.history || !history.pushState || !window.fetch || !window.DOMParser) return;

  var SECTIONS = ['tca_hero', 'tca_tiles', 'tca_about'];
  var shown = location.pathname; // kolekcja, której sekcje są teraz na ekranie
  var pending = false;
  var cache = {};
  var token = 0;

  function ready() {
    try { return !!(window.__BOOST_TAE_LIQUID__ && window.boostWidgetIntegration && window.boostWidgetIntegration.status === 'ready' && window.boostSDTaeUtils && window.boostSDTaeUtils.initCollectionFilter); } catch (e) { return false; }
  }
  function settings() {
    var a = [];
    try { a.push(window.__BOOST_TAE_LIQUID__.generalSettings); } catch (e) {}
    try { a.push(window.boostWidgetIntegration.app.production.generalSettings); } catch (e) {}
    return a.filter(function (g, i) { return g && a.indexOf(g) === i; });
  }
  function current() {
    var g = settings()[0] || {};
    return { cid: g.collection_id, h: g.collection_handle, n: g.collection_product_count, s: g.default_sort_by, tpl: g.template };
  }
  function apply(d) {
    settings().forEach(function (g) {
      if (d.cid) g.collection_id = +d.cid;
      if (d.h) g.collection_handle = d.h;
      if (d.n !== undefined && d.n !== '' && d.n !== null) g.collection_product_count = +d.n;
      if (d.s) g.default_sort_by = d.s;
      if (d.tpl) g.template = d.tpl;
      g.current_tags = null;
      g.collection_tags = null;
    });
    // mapa uchwyt → id, z której Boost sam korzysta przy „wstecz” (inaczej pobrałby całość sklepu)
    try {
      var k = 'boost_sd_collection_id_key', map = JSON.parse(sessionStorage.getItem(k) || '{}') || {};
      var seg = location.pathname.split('/collections/')[1];
      if (d.cid) {
        if (d.h) map[d.h] = +d.cid;
        if (seg) map[decodeURIComponent(seg.split('/')[0])] = +d.cid;
        sessionStorage.setItem(k, JSON.stringify(map));
      }
    } catch (e) {}
  }
  // dane kolekcji z HTML strony (gdy nie mamy ich z kafelka, np. wstecz)
  function dataFromHtml(html) {
    var d = {}, i = html.indexOf('function readPayload');
    var t = i >= 0 ? html.slice(i, i + 4000) : '';
    var m = t.match(/collection_id:\s*(\d+)/); if (m) d.cid = m[1];
    m = t.match(/collection_handle:\s*"([^"]+)"/); if (m) d.h = m[1];
    m = t.match(/collection_product_count:\s*(\d+)/); if (m) d.n = m[1];
    m = t.match(/default_sort_by:\s*"([^"]+)"/); if (m) d.s = m[1];
    m = t.match(/\btemplate:\s*"(collection[^"]*)"/); if (m) d.tpl = m[1];
    return d;
  }
  function key(el) { var m = (el.id || '').match(/__([^_].*)$/); return m ? m[1] : ''; }
  function sectionsOf(root) {
    var o = {};
    root.querySelectorAll('[id^="shopify-section-template--"]').forEach(function (el) {
      var k = key(el);
      if (el.querySelector('.boost-sd__filter-product-list')) k = 'boost';
      o[k] = el;
    });
    return o;
  }
  function runScripts(root) {
    root.querySelectorAll('script').forEach(function (s) {
      var t = (s.getAttribute('type') || '').toLowerCase();
      if (t && t !== 'text/javascript' && t !== 'module' && t !== 'application/javascript') return;
      var n = document.createElement('script');
      for (var i = 0; i < s.attributes.length; i++) n.setAttribute(s.attributes[i].name, s.attributes[i].value);
      n.textContent = s.textContent;
      s.parentNode.replaceChild(n, s);
    });
  }
  function load(path) {
    var c = cache[path];
    if (c && Date.now() - c.t < 90000) return c.p;
    var p = fetch(path, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok || (r.redirected && new URL(r.url).pathname.indexOf('/collections/') === -1)) throw new Error('status ' + r.status);
      return r.text();
    });
    cache[path] = { t: Date.now(), p: p };
    p.catch(function () { delete cache[path]; });
    return p;
  }
  function loading(on) { document.documentElement.classList.toggle('tilt-soft-loading', !!on); }

  function swap(html, path, my, d) {
    if (my !== token) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nw = sectionsOf(doc), old = sectionsOf(document);
    if (!nw.tca_tiles || !old.tca_tiles || !nw.tca_hero || !nw.boost || !old.boost || !ready()) { location.replace(path); return; }
    var dd = dataFromHtml(html);
    Object.keys(d || {}).forEach(function (k) { if (d[k] && !dd[k]) dd[k] = d[k]; });
    SECTIONS.concat(['boost']).forEach(function (k) {
      if (!nw[k] || !old[k]) return;
      var imp = document.importNode(nw[k], true);
      old[k].parentNode.replaceChild(imp, old[k]);
      if (k !== 'boost') runScripts(imp);
    });
    apply(dd);
    shown = location.pathname;
    pending = false;
    try { window.boostSDTaeUtils.initCollectionFilter(); } catch (e) { location.replace(path); return; }
    if (doc.title) document.title = doc.title;
    ['meta[name="description"]', 'link[rel="canonical"]'].forEach(function (sel) {
      var a = document.head.querySelector(sel), b = doc.head.querySelector(sel);
      if (a && b) a.replaceWith(document.importNode(b, true));
    });
    try { var st = history.state || {}; if (!st.cid && dd.cid) history.replaceState(Object.assign({}, st, { tiltSoft: 1, cid: dd.cid, h: dd.h, n: dd.n, s: dd.s, tpl: dd.tpl }), ''); } catch (e) {}
    loading(false);
    var top = document.querySelector('.tct-set');
    if (top) { var r = top.getBoundingClientRect(); if (r.top < 0) window.scrollTo({ top: window.scrollY + r.top - 80, behavior: 'smooth' }); }
  }
  function dataOf(a) {
    var d = a.dataset || {};
    return { cid: d.cid, h: d.h, n: d.n, s: d.s, tpl: d.tpl, t: d.t };
  }
  function go(a, href) {
    var url = new URL(href, location.href);
    var ctx = url.searchParams.get('ctx') || '';
    url.searchParams.delete('ctx');
    var path = url.pathname + url.search;
    var d = dataOf(a);
    var my = ++token;
    // od razu: podświetlenie, nagłówek, adres
    var nav = a.closest('.tct');
    if (nav) {
      nav.querySelectorAll('.tct__tile.is-on').forEach(function (x) { x.classList.remove('is-on'); x.removeAttribute('aria-current'); });
      a.classList.add('is-on'); a.setAttribute('aria-current', 'page');
    }
    var h1 = document.querySelector('.tch-set > .tch:not([hidden]) .tch__h');
    if (h1 && d.t) h1.textContent = d.t;
    window.__tcr = ctx;
    try { if (ctx) sessionStorage.setItem('tilt_ctx', JSON.stringify({ p: url.pathname, h: ctx })); } catch (e) {}
    history.pushState({ tiltSoft: 1, cid: d.cid, h: d.h, n: d.n, s: d.s, tpl: d.tpl, ctx: ctx }, '', path + url.hash);
    loading(true);
    pending = true;
    load(path).then(function (html) { swap(html, path, my, d); }).catch(function () { if (my === token) location.replace(path); });
  }

  // stan bieżącej strony (do „wstecz”)
  try {
    var s0 = history.state || {};
    if (!s0.tiltSoft) {
      var c0 = current();
      history.replaceState(Object.assign({}, s0, { tiltSoft: 1, cid: c0.cid, h: c0.h, n: c0.n, s: c0.s, tpl: c0.tpl, ctx: window.__tcr || '' }), '');
    }
  } catch (e) {}

  // faza przechwytywania na window: przed obsługą motywu (przejścia stron), która sama przeładowałaby stronę
  window.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a.tct__tile[href]');
    if (!a || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (!a.dataset.cid || !ready()) return;
    var u = new URL(a.getAttribute('href'), location.href);
    if (u.origin !== location.origin || u.pathname.indexOf('/collections/') === -1) return;
    e.preventDefault();
    e.stopPropagation();
    if (u.pathname === location.pathname && !u.searchParams.get('ctx')) return;
    go(a, u.href);
  }, true);

  function pathOf(a) {
    var u = new URL(a.getAttribute('href'), location.href);
    u.searchParams.delete('ctx');
    return u.pathname === location.pathname ? '' : u.pathname + u.search;
  }
  function warm(e) {
    var a = e.target && e.target.closest && e.target.closest('a.tct__tile[href]');
    if (!a || !a.dataset.cid) return;
    var p = pathOf(a);
    if (p) load(p);
  }
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('touchstart', warm, { passive: true });
  document.addEventListener('focusin', warm);

  // w tle: Bestsellery, Nowości i sąsiedzi bieżącego kafelka
  function idlePrefetch() {
    try {
      var c = navigator.connection;
      if (c && (c.saveData || /2g|3g/.test(c.effectiveType || ''))) return;
    } catch (e) {}
    var nav = document.querySelector('.tct-set .tct:not([hidden])');
    if (!nav) return;
    var tiles = [].slice.call(nav.querySelectorAll('a.tct__tile[data-cid]'));
    var pick = tiles.filter(function (a) { return a.closest('.tct__item--shop'); }).slice(0, 2);
    var on = nav.querySelector('a.tct__tile.is-on');
    var i = tiles.indexOf(on);
    if (i >= 0) { if (tiles[i + 1]) pick.push(tiles[i + 1]); if (i > 0 && tiles[i - 1]) pick.push(tiles[i - 1]); }
    pick.slice(0, 4).forEach(function (a, k) { var p = pathOf(a); if (p) setTimeout(function () { load(p); }, k * 400); });
  }
  var ric = window.requestIdleCallback || function (f) { return setTimeout(f, 1500); };
  function startIdle() { setTimeout(function () { ric(idlePrefetch); }, 1500); }
  if (document.readyState === 'complete') startIdle(); else window.addEventListener('load', startIdle);

  // wstecz / dalej
  window.addEventListener('popstate', function (e) {
    // ta sama kolekcja (np. zmiana filtra) – obsługuje sam Boost
    if (location.pathname === shown) { if (pending) { pending = false; ++token; location.reload(); } return; }
    var st = e.state || {};
    var path = location.pathname + location.search;
    var my = ++token;
    window.__tcr = st.ctx || '';
    loading(true);
    load(path).then(function (html) { swap(html, path, my, st); }).catch(function () { if (my === token) location.reload(); });
  });

  var css = document.createElement('style');
  css.textContent = '.tilt-soft-loading .boost-sd__product-list,.tilt-soft-loading .boost-sd-right{opacity:.45;transition:opacity .15s}';
  document.head.appendChild(css);
})();
